import React, { useEffect, useState } from 'react';
import '../../styles/csr.css';
import SubLinks from '../../components/header/SubLinks.jsx';
import { adminLinks } from '../../config/standard-links.js';
import RequirementForm from '../../components/csr/RequirementForm.jsx';
// import TicketPreviewList from '../../components/csr/TicketPreviewList.jsx';
import RequirementKanban from '../../components/csr/RequirementKanban.jsx';
import useSystemRequirements from '../../hooks/useSystemRequirement.js';
import EmailLogTable from '../../components/csr/EmailLogTable.jsx';
// import useHipaa from '../../hooks/useHipaa.js';

const ComputerSystemRequirement = () => {
    const {
        requirements,
        loading,
        error,
        getAllSystemRequirements,
        createSystemRequirement,
        updateSystemRequirementScore,
        deleteSystemRequirement,
        fetchAndSaveComputerSpecs
    } = useSystemRequirements();

    const [showEmailLog, setShowEmailLog] = useState(false);

    // const { sendCsrEmail, isSendEmailSuccess } = useHipaa();

    // Load requirements on page load
    useEffect(() => {
        getAllSystemRequirements();
    }, [getAllSystemRequirements]);
    // Handle form submission
    const handleFormSubmit = async (formData) => {
        const { category } = formData;
        let details = '';

        switch (category) {
            case 'RAM':
                details = `${formData.min}GB - ${formData.max}GB`;
                break;
            case 'Disk':
                details = `Free Space: ${formData.minPercentFree}% - ${formData.maxPercentFree}%`;
                break;
            case 'Internet':
                details = `Minimum Download: ${formData.minDownload} Mbps, Minimum Upload: ${formData.minUpload} Mbps, Maximum Ping: ${formData.maxPing} ms`;
                break;
            default:
                details = JSON.stringify(formData);
                break;
        }

        const newRequirement = {
            category: category || 'Unknown',
            details,
            score: 0,
            createdBy: 'FrontendTestUser'
        };

        try {
            await createSystemRequirement(newRequirement);
        } catch (err) {
            console.error('Error creating requirement:', err);
        }
    };

    // Handle drag-and-drop score update
    const handleScoreUpdate = async (ticketId, newScore) => {
        try {
            await updateSystemRequirementScore(ticketId, newScore);
        } catch (err) {
            console.error('Error updating score:', err);
        }
    };

    // Handle ticket deletion
    const handleTicketDelete = async (ticketId) => {
        try {
            await deleteSystemRequirement(ticketId);
        } catch (err) {
            console.error('Error deleting requirement:', err);
        }
    };
    // const handleClick = async () => {
    //     await sendCsrEmail('65cbf2c065501e65fa649125');
    // };

    return (
        <div>
            <SubLinks links={adminLinks} />
            <div className="csr-container">
                <br />
                <br />
                <br />
                <div className="create-office-heading csr-heading-with-button">
                    <span>Computer System Requirements (CSR)</span>
                    <button
                        className="csr-fetch-button"
                        onClick={() => setShowEmailLog(true)}>
                        View Email Log
                    </button>
                    <button
                        className="csr-fetch-button"
                        onClick={fetchAndSaveComputerSpecs}
                        disabled={loading.fetchSpecs}>
                        {loading.fetchSpecs
                            ? 'Fetching...'
                            : 'Fetch Computer Specs'}
                    </button>
                    {/* <button className="csr-fetch-button" onClick={handleClick}>
                        Send Email
                    </button>

                    {isSendEmailSuccess && <p>Email sent successfully.</p>}
                    {error && <p className="error">Error: {error.message}</p>} */}
                </div>
                <div className="csr-scrollable-content">
                    {/* Flex container: Left (Form + List), Right (Kanban) */}
                    <div className="csr-main-content">
                        {showEmailLog ? (
                            <EmailLogTable
                                onBack={() => setShowEmailLog(false)}
                            />
                        ) : (
                            <>
                                {/* Left side */}
                                <div className="csr-left">
                                    {/* Requirement Form (Not Scrollable) */}
                                    <RequirementForm
                                        onSubmit={handleFormSubmit}
                                        isSubmitting={loading.create}
                                    />
                                    {error && (
                                        <p className="error">{error.message}</p>
                                    )}
                                </div>

                                {/* Right side */}
                                <div className="csr-right">
                                    <RequirementKanban
                                        tickets={requirements}
                                        onScoreUpdate={handleScoreUpdate}
                                        onDelete={handleTicketDelete}
                                        loading={loading}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ComputerSystemRequirement;
